import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import common from "../../frontend/src/plugins/common";
import vuetify from "./plugins/vuetify";

Vue.config.productionTip = false;

Vue.use(common);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
